import React, { useEffect, useState } from "react";
import { TableCell, Switch, Typography, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// Components
import Box from "@/main/components/shared/box";
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import KogAutoCompleteVehicleControlled from "@/main/components/shared/inputAutoComplete/autoCompleteVehicleControlled";
import Button from "@/main/components/shared/button/button";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";
import ResultNotFoundComponent from "@/main/components/shared/resultNotFound/resultNotFoundComponent";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";

// Api's
import { getCountriesUser, useCountryReducer } from "@/main/store/country";
import {
	getSupplierInventoryWarehouseStatus,
	useSupplierInventoryWarehouseStatusReducer,
} from "@/main/store/supplierInventoryWarehouseStatus";

import { getSuppliers, resetReducerSuppliers, useSupplierReducer } from "@/main/store/supplier";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { getManufacturers, resetReducerManufacturers, useManufacturerReducer } from "@/main/store/vehicle/manufacturer";
import {
	CompanyFilterRequest,
	ManufacturerRequest,
	ModelRequest,
	SubModelRequest,
	SupplierInventoryRequest,
	WarehouseFilterRequest,
} from "@/main/models/request";
import { getModels, resetReducerModels, useModelReducer } from "@/main/store/vehicle/model";
import { getSubModels, resetReducerSubModels, useSubModelReducer } from "@/main/store/vehicle/subModel";
import { getWarehouse, resetReducerWarehouse, useWarehouseReducer } from "@/main/store/warehouse";
import { KeyValue } from "@/main/models/common";
import { SupplierFilterRequest } from "@/main/models/request/supplierRequest";
import { SupplierInventoryDataResponse } from "@/main/models/response";
import { supplierInventoryApi } from "@/main/api";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { HeadQuarterBranchFilterEnum } from "@/main/services/enum/HeadQuarterBranchFilterEnum";
import {
	getDefaultCountryOptionDrop,
	getDefaultMessageResultsFound,
	getDefaultOptionDrop,
	getTranslateByKey,
	haveIgnoreElement,
	isNullUndefined,
	isValueQueryParams,
	removeEmptyValues,
} from "@/main/services/utils";
import { formatCurrency } from "@/main/services/utilsNumber";
import * as S from "./styles";
import ModalImportInvetory from "../importInventory/components/modalImportInventory";
import { toast } from "react-toastify";
import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import { withQueryparams } from "@/main/components/core/queryParams/queryparams";
import useFormQueryParams from "@/main/hooks/useformQueryParams";
import Close from "@mui/icons-material/Close";
import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";
import ModalConfirmDeletePart from "../components/modalConfirmDeletePart/modalConfirmDeletePart";
import KogInputAutoCompleteCheckControlled from "@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled";
import { getCompanyType, useCompanyTypeReducer } from "@/main/store/companyType";
import { CompanyTypeEnum } from "@/main/services/enum/CompanyTypeEnum";
import { getCompany, resetReducerCompany, useCompanyReducer } from "@/main/store/company";
import { KOGAreaButtons } from "@/main/components/shared/styles";

export interface ISearchPartsCatalogForm {
	tab: number;
	country: KeyValue | null;
	supplier: KeyValue | null;
	warehouse: KeyValue | null;
	sku: string | null;
	title: string | null;
	make: KeyValue | null;
	model: KeyValue | null;
	trim: KeyValue | null;
	tradeName: string | null;
	supplierInventoryWarehouseStatus: KeyValue | null;
	companyType: KeyValue | null;
	company: KeyValue[] | null;
}

interface IGridData {
	data: SupplierInventoryDataResponse[];
	totalItems: number;
	isLoading: boolean;
}

interface IPropsPartsCatalogTab {
	showFilters: boolean;
	setShowFilters: (showFilters: boolean) => void;
	openModalImportInventory: boolean;
	closeModalImportInventory: () => void;
	filesModalImportInventory: File[];
	setFilesModalImportInventory: React.Dispatch<React.SetStateAction<File[]>>;
	setTabCurrent: (tab: number) => void;
	searchGridHistory: (form: any) => void;
	exporting: boolean;
	setExporting: (value: boolean) => void;
	uploading: boolean;
	setUploading: (value: boolean) => void;
}

interface IPropsSupplierSearchGrid {
	gridData: IGridData;
	formFilters: SupplierFilterRequest | null;
	setFormFilters: (formFilters: SupplierFilterRequest | null) => void;
	getGridData: (formFilters: SupplierFilterRequest) => void;
	hasShowMore: boolean;
	pageIndex: number;
	setPageIndex: (index: number) => void;
	isLoadingInfiniteScroll: boolean;
	refreshGrid: () => void;
}

const SupplierSearchGrid = ({
	gridData,
	formFilters,
	setFormFilters,
	getGridData,
	hasShowMore,
	pageIndex,
	setPageIndex,
	isLoadingInfiniteScroll,
	refreshGrid,
}: IPropsSupplierSearchGrid) => {
	const navigate = useNavigate();
	const [switchStates, setSwitchStates] = useState<{ [key: string]: boolean }>({});
	const [partForChangeStatus, setPartForChangeStatus] = useState<string>("");
	const [open, setOpen] = useState(false);
	const [isOpenModalConfirmDelete, setIsOpenModalConfirmDelete] = useState(false);
	const [guidModalConfirmDelete, setGuidModalConfirmDelete] = useState("");

	const handleOpen = () => setOpen(true);
	const rowHeaders = [
		getTranslateByKey("information.concatcompany"),
		getTranslateByKey("information.sku"),
		getTranslateByKey("information.title"),
		getTranslateByKey("information.description"),
		getTranslateByKey("information.type"),
		getTranslateByKey("information.amount"),
		getTranslateByKey("information.shippingPrice"),
		getTranslateByKey("information.autoDeliveryWithCost"),
		getTranslateByKey("information.autoDeliverywithoutPrice"),
		getTranslateByKey("information.status"),
		"",
	];

	useEffect(() => {
		const initialSwitchStates: { [key: string]: boolean } = {};
		if (gridData.data.length > 0 && gridData.data !== undefined) {
			gridData.data.forEach((parts) => {
				initialSwitchStates[parts.supplierInventoryWarehouseGuid] =
					String(parts.status) === getTranslateByKey("supplierInventoryWarehouseStatus.available");
			});
			setSwitchStates(initialSwitchStates);
		}
	}, [gridData.data]);

	function onLoadSearchGrid() {
		const index = pageIndex + PaginationEnum.PageIndexIntial;
		setPageIndex(index);

		const formFiltersOnLoadSearchGrid = formFilters;
		if (formFiltersOnLoadSearchGrid) {
			formFiltersOnLoadSearchGrid.pageIndex = index;

			setFormFilters(formFiltersOnLoadSearchGrid);
			getGridData(formFiltersOnLoadSearchGrid);
		}
	}

	function handleToggleStatus(supplierInventoryWarehouseGuid: string) {
		if (switchStates[supplierInventoryWarehouseGuid] === true) {
			setPartForChangeStatus(supplierInventoryWarehouseGuid);
			handleOpen();
		} else {
			changeStatus(supplierInventoryWarehouseGuid);
		}
	}

	function changeStatus(supplierInventoryWarehouseGuid: string) {
		const request = {
			supplierInventoryWarehouseGuid: String(supplierInventoryWarehouseGuid),
		} as SupplierInventoryRequest;

		supplierInventoryApi.changeStatusPartsCatalog(request).then(() => {
			toast.success(getTranslateByKey("information.partStatusChangedSuccessfully"));
			setSwitchStates((prevSwitchStates) => ({
				...prevSwitchStates,
				[supplierInventoryWarehouseGuid]: !prevSwitchStates[supplierInventoryWarehouseGuid],
			}));
		});
	}

	function handleRowBoxGrid(
		guidSupplierInventory: string,
		guidSupplierInventoryWarehouse: string,
		event: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
	) {
		if (haveIgnoreElement(event.target as HTMLElement)) return;

		navigate(
			`${RoutesConstants.inventoryRegister}?guidSupplierInventory=${guidSupplierInventory}&guidSupplierInventoryWarehouse=${guidSupplierInventoryWarehouse}`,
		);
	}
	function openModalConfirmDelete(part: SupplierInventoryDataResponse) {
		setGuidModalConfirmDelete(part.supplierInventoryWarehouseGuid);
		setIsOpenModalConfirmDelete(true);
	}
	const titleGrid = getDefaultMessageResultsFound(gridData.data.length, gridData.totalItems);

	if (gridData.isLoading) return <LoadingComponent />;
	if (gridData.data.length === 0 && formFilters !== null) return <ResultNotFoundComponent styles={{ marginTop: 10 }} />;
	if (gridData.data.length === 0 && !gridData.isLoading) return null;

	return (
		<>
			<KogModalFadeComponent open={open} setOpen={setOpen}>
				<S.BoxModal>
					<Typography id="id-modal-partsCatalog-title" variant="h6" component="h2">
						{getTranslateByKey("information.warning")}
					</Typography>
					<Typography id="id-modal-partsCatalog-description">
						{getTranslateByKey("information.questionForChangeStatus")}
					</Typography>
					<Typography id="id-modal-partsCatalog-description">
						{getTranslateByKey("information.messageConfirmAction")}
					</Typography>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							gap: "1rem",
						}}
					>
						<SecondaryButton type="button" style={{ marginTop: 10 }} onClick={() => setOpen(false)}>
							{getTranslateByKey("information.no")}
						</SecondaryButton>
						<Button
							type="button"
							style={{ marginTop: 10 }}
							onClick={() => {
								changeStatus(partForChangeStatus);
								setOpen(false);
							}}
						>
							{getTranslateByKey("information.yes")}
						</Button>
					</div>
				</S.BoxModal>
			</KogModalFadeComponent>
			<BoxGrid
				title={titleGrid}
				rowHeaders={rowHeaders}
				infiniteScrollConfig={{
					dataLength: gridData.data.length,
					fetchData: () => onLoadSearchGrid(),
					hasMore: hasShowMore,
					isLoading: isLoadingInfiniteScroll,
				}}
			>
				{gridData.data.map((parts: SupplierInventoryDataResponse) => (
					<KOGTableRow
						onClick={(e) => handleRowBoxGrid(parts.supplierInventoryGuid, parts.supplierInventoryWarehouseGuid, e)}
						key={parts.supplierInventoryWarehouseGuid}
					>
						<TableCell
							width="10%"
							title={parts.companyConcat}
							style={{
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
								maxWidth: "150px",
							}}
						>
							{parts.companyConcat}
						</TableCell>
						<TableCell width="10%">{parts.sku}</TableCell>
						<TableCell width="10%">{parts.title}</TableCell>
						<TableCell width="10%">{parts.description}</TableCell>
						<TableCell width="10%">{parts.type}</TableCell>
						<TableCell width="10%">{parts.amount}</TableCell>
						<TableCell width="10%">{formatCurrency(parts.shippingPrice)}</TableCell>
						<TableCell width="10%">{formatCurrency(parts.autoDeliveryPriceWithCost)}</TableCell>
						<TableCell width="10%">{formatCurrency(parts.autoDeliveryPrice)}</TableCell>
						<TableCell width="5%">
							{String(parts.status) !== `${getTranslateByKey("supplierInventoryWarehouseStatus.pendingToMap")}` ? (
								<Switch
									className="ignore-click"
									color="primary"
									checked={switchStates[parts.supplierInventoryWarehouseGuid] === true}
									disabled={Number(parts.amount) <= 0}
									onChange={() => handleToggleStatus(parts.supplierInventoryWarehouseGuid)}
								/>
							) : (
								<S.ContainerPending>
									{`${getTranslateByKey("supplierInventoryWarehouseStatus.pendingToMap")}`}
								</S.ContainerPending>
							)}
						</TableCell>
						<TableCell width="2%">
							<TooltipComponent title={"Remove part"} placement="top">
								<IconButton
									className="ignore-click"
									onClick={() => {
										openModalConfirmDelete(parts);
									}}
								>
									<Close fontSize="small" />
								</IconButton>
							</TooltipComponent>
						</TableCell>
					</KOGTableRow>
				))}
				<ModalConfirmDeletePart
					supplierInventoryWarehouseGuid={guidModalConfirmDelete}
					openModalConfirm={isOpenModalConfirmDelete}
					setOpenModalConfirm={setIsOpenModalConfirmDelete}
					callbackAfterRemovePart={() => {
						refreshGrid();
					}}
				/>
			</BoxGrid>
		</>
	);
};
const ID_TAB_PARTS_CATALOG = 1;
function PartsCatalogTab({
	showFilters,
	setShowFilters,
	openModalImportInventory,
	closeModalImportInventory,
	filesModalImportInventory,
	setFilesModalImportInventory,
	setTabCurrent,
	searchGridHistory,
	exporting,
	setExporting,
	uploading,
	setUploading,
}: IPropsPartsCatalogTab) {
	const dispatch = useDispatch();

	// State & reducers
	const countryReducer = useCountryReducer();
	const { supplierInventoryWarehouseStatus: supplierInventoryWarehouseStatusReducer } =
		useSupplierInventoryWarehouseStatusReducer();
	const supplierReducer = useSupplierReducer();
	const warehouseReducer = useWarehouseReducer();
	const manufacturerReducer = useManufacturerReducer();
	const modelReducer = useModelReducer();
	const subModelReducer = useSubModelReducer();
	const companyTypeReducer = useCompanyTypeReducer();
	const companyReducer = useCompanyReducer();

	const optionDefaultCountryDrop = getDefaultCountryOptionDrop(countryReducer.countriesUser.data);

	const optionDefaultSupplierDrop = getDefaultOptionDrop(supplierReducer.suppliers.data);

	const optionDefaultWarehouseDrop = getDefaultOptionDrop(warehouseReducer.warehouse.data);

	const optionDefaultCompanyTypeDrop = getDefaultOptionDrop(companyTypeReducer.companyType.data);

	const INITIAL_FORM_STATE: ISearchPartsCatalogForm = {
		tab: ID_TAB_PARTS_CATALOG,
		country: null,
		supplier: null,
		warehouse: null,
		sku: "",
		title: "",
		make: null,
		model: null,
		trim: null,
		supplierInventoryWarehouseStatus: null,
		tradeName: "",
		companyType: null as KeyValue | null,
		company: [] as KeyValue[] | null,
	};
	const {
		control,
		queryParamsValues,
		customHandleSubmit,
		setValue,
		formState: { errors },
		reset,
		watch,
		getValues,
	} = useFormQueryParams<ISearchPartsCatalogForm>({
		mode: "onChange",
		defaultValues: INITIAL_FORM_STATE,
		validQueryParams: {
			tab: INITIAL_FORM_STATE.tab,
		},
		mapDefaultValues: {
			country: countryReducer.countriesUser,
			make: manufacturerReducer.manufacturers,
			model: modelReducer.models,
			supplier: supplierReducer.suppliers,
			supplierInventoryWarehouseStatus: supplierInventoryWarehouseStatusReducer,
			trim: subModelReducer.subModels,
			warehouse: warehouseReducer.warehouse,
			company: companyReducer.company,
			companyType: companyTypeReducer.companyType,
		},
		onSubmit: onSubmit,
	});
	const INITIAL_GRID_STATE: IGridData = {
		totalItems: 0,
		isLoading: false,
		data: [],
	};
	const [gridData, setGridData] = useState<IGridData>(INITIAL_GRID_STATE);
	const [formFilters, setFormFilters] = useState<SupplierFilterRequest | null>(null);
	const [hasShowMore, setHasShowMore] = useState<boolean>(false);
	const [pageIndex, setPageIndex] = useState<number>(PaginationEnum.PageIndexIntial);
	const [isLoadingInfiniteScroll, setIsLoadingInfiniteScroll] = useState<boolean>(false);

	const watcherMake = watch("make");

	const isDisabledSupplierDrop = () => supplierReducer.suppliers.data === null || getValues().country === null;
	const isDisabledModelDrop = () =>
		modelReducer.models.data === null || manufacturerReducer.manufacturers.data === null;

	const isDisabledSubModelDrop = () =>
		subModelReducer.subModels.data === null ||
		modelReducer.models.data === null ||
		manufacturerReducer.manufacturers.data === null;

	const isDisabledWarehouseDrop = () =>
		warehouseReducer.warehouse.data === null || supplierReducer.suppliers.data === null;

	const isDisabledCompanyTypeDrop = () => companyTypeReducer.companyType.data === null;

	const isDisabledCompanyDrop = () => getValues().companyType === null;

	function handleClear() {
		reset(INITIAL_FORM_STATE);
		setValue("supplierInventoryWarehouseStatus", null);
		setValue("warehouse", null);
		setGridData(INITIAL_GRID_STATE);
		setFormFilters(null);
		setPageIndex(PaginationEnum.PageIndexIntial);
		setHasShowMore(false);
		setIsLoadingInfiniteScroll(false);

		if (optionDefaultCountryDrop) {
			setValue("country", optionDefaultCountryDrop);
			callSupplierApiDomain(optionDefaultCountryDrop);
			callManufacturersApiDomain(optionDefaultCountryDrop);
		} else {
			dispatch(resetReducerSuppliers());
		}
		if (optionDefaultSupplierDrop) {
			setValue("supplier", optionDefaultSupplierDrop);
			callWarehouseApiDomain(optionDefaultSupplierDrop);
		} else {
			dispatch(resetReducerWarehouse());
		}

		if (companyTypeReducer.companyType.data !== null) {
			const keyCompanyType = String(CompanyTypeEnum.Insurer);
			const valueCompanyType = String(
				companyTypeReducer.companyType.data?.find((x) => x.key === keyCompanyType)?.value,
			);
			setValue("companyType", {
				key: keyCompanyType,
				value: valueCompanyType,
			});
		}
		setValue("companyType", optionDefaultCompanyTypeDrop);
		if (optionDefaultCountryDrop !== null && optionDefaultCompanyTypeDrop !== null) {
			callCompanyApiDomain(optionDefaultCountryDrop, optionDefaultCompanyTypeDrop);
		}
	}

	const onlyShowCompanyTypes = [CompanyTypeEnum.Insurer, CompanyTypeEnum.BodyShop];
	const optionsFilteredCompanyType = isNullUndefined(companyTypeReducer.companyType.data)
		? null
		: companyTypeReducer.companyType.data
				.filter((item) => onlyShowCompanyTypes.includes(Number(item.key)))
				.sort((a, b) => a.value.localeCompare(b.value));

	function callSupplierApiDomain(optionSelected: KeyValue | null, isReset = true) {
		// Clean fields & reducers
		if (isReset) {
			setValue("supplier", null);
			dispatch(resetReducerSuppliers());
		}

		if (optionSelected !== null) {
			const request: SupplierFilterRequest = {
				guidCountry: String(optionSelected.key),
				type: HeadQuarterBranchFilterEnum.All,
				idStatusRegister: StatusRegisterEnum.Active,
			};
			dispatch(getSuppliers(request));
		}
	}

	function callWarehouseApiDomain(optionSelected: KeyValue | null, isReset = true) {
		// Clean fields & reducers
		if (isReset) {
			setValue("warehouse", null);
			dispatch(resetReducerWarehouse());
		}

		if (optionSelected !== null) {
			const request: WarehouseFilterRequest = {
				guidSupplier: String(optionSelected.key),
			};
			dispatch(getWarehouse(request));
		}
	}

	function callCompanyApiDomain(countrySelected: KeyValue | null, companyTypeSelected: KeyValue | null) {
		if (!isValueQueryParams(countrySelected) || !isValueQueryParams(companyTypeSelected)) {
			setValue("company", null);
		}
		dispatch(resetReducerCompany());

		if (countrySelected !== null) {
			const request: CompanyFilterRequest = {
				guidCountry: String(countrySelected.key),
				type: HeadQuarterBranchFilterEnum.All,
			};
			if (companyTypeSelected) {
				request.idCompanyType = String(companyTypeSelected.key);
				dispatch(getCompany(request));
			}
		}
	}

	function callManufacturersApiDomain(optionSelected: KeyValue | null, isReset = true) {
		if (isReset) {
			setValue("make", null);
			setValue("model", null);
			setValue("trim", null);
			dispatch(resetReducerManufacturers());
			dispatch(resetReducerModels());
			dispatch(resetReducerSubModels());
		}

		if (optionSelected !== null) {
			const requestMake: ManufacturerRequest = {};
			dispatch(getManufacturers(requestMake));
		}
	}

	function callModelApiDomain(optionSelected: KeyValue | null, isReset = true) {
		if (isReset) {
			setValue("model", null);
			setValue("trim", null);
			dispatch(resetReducerModels());
			dispatch(resetReducerSubModels());
		}

		if (optionSelected !== null) {
			const request: ModelRequest = {
				guidManufacturer: String(optionSelected.key),
			};
			dispatch(getModels(request));
		}
	}

	function callSubModelApiDomain(optionManufacturer: KeyValue | null, optionSelected: KeyValue | null, isReset = true) {
		if (isReset) {
			setValue("trim", null);
			dispatch(resetReducerSubModels());
		}
		if (optionSelected !== null && optionManufacturer !== null) {
			const request: SubModelRequest = {
				guidManufacturer: String(optionManufacturer?.key),
				guidModel: String(optionSelected.key),
			};
			dispatch(getSubModels(request));
		}
	}

	function onSubmit(formInputs: ISearchPartsCatalogForm) {
		setPageIndex(PaginationEnum.PageIndexIntial);
		setGridData({
			isLoading: true,
			totalItems: 0,
			data: [],
		});

		const requestForm: SupplierInventoryRequest = {
			guidWarehouse: String(formInputs.warehouse?.key),
			guidMake: !isNullUndefined(formInputs.make?.key) ? String(formInputs.make?.key) : null,
			guidModel: !isNullUndefined(formInputs.model?.key) ? String(formInputs.model?.key) : null,
			guidSubmodel: !isNullUndefined(formInputs.trim?.key) ? String(formInputs.trim?.key) : null,
			sku: !isNullUndefined(formInputs.sku) ? formInputs.sku : null,
			title: !isNullUndefined(formInputs.title) ? formInputs.title : null,
			status: formInputs.supplierInventoryWarehouseStatus?.key
				? Number(formInputs.supplierInventoryWarehouseStatus.key)
				: null,
			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize30,
			idCompanyType: !isNullUndefined(formInputs.companyType?.key) ? String(formInputs.companyType?.key) : null,
			guidCompany: formInputs.company?.map((item) => String(item.key)),
		};

		setFormFilters(requestForm);
		const requestFormatted = removeEmptyValues(requestForm);

		supplierInventoryApi.getSearchGrid(requestFormatted).then((response) => {
			setGridData({
				isLoading: false,
				totalItems: response.data.totalNumberOfRecords,
				data: response.data.results,
			});
			setHasShowMore(response.data.results.length < response.data.totalNumberOfRecords);
		});
		setShowFilters(false);
	}

	function onLoadInfiniteScroll(request: SupplierFilterRequest) {
		setIsLoadingInfiniteScroll(true);
		supplierInventoryApi
			.getSearchGrid(request)
			.then((response) => {
				let resultData: SupplierInventoryDataResponse[] = [];
				let resultTotalItems: number = 0;
				if (response.data && response.data.results && response.data.results.length > 0) {
					resultData = response.data.results;
					resultTotalItems = response.data.totalNumberOfRecords;
				}
				if (gridData.data.length > 0) {
					resultData = [...gridData.data, ...resultData];
				}
				setGridData({
					isLoading: false,
					totalItems: resultTotalItems,
					data: resultData,
				});

				// Disable show more
				if (resultTotalItems < PaginationEnum.PageSize30 || resultTotalItems === resultData.length) {
					setHasShowMore(false);
				}
			})
			.finally(() => setIsLoadingInfiniteScroll(false));
	}

	function refreshGrid() {
		if (formFilters) {
			setPageIndex(PaginationEnum.PageIndexIntial);
			setGridData({
				isLoading: true,
				totalItems: 0,
				data: [],
			});

			supplierInventoryApi.getSearchGrid(formFilters).then((response) => {
				setGridData({
					isLoading: false,
					totalItems: response.data.totalNumberOfRecords,
					data: response.data.results,
				});
				setHasShowMore(response.data.results.length < response.data.totalNumberOfRecords);
			});
		}
	}

	//#region UseEffect's
	// Initial load
	useEffect(() => {
		dispatch(getCountriesUser());
		dispatch(getSupplierInventoryWarehouseStatus());
		dispatch(getCompanyType());

		return () => {
			dispatch(resetReducerSuppliers());
		};
	}, []);

	useEffect(() => {
		// Call API's related by country default
		if (optionDefaultCountryDrop) {
			callSupplierApiDomain(optionDefaultCountryDrop, false);
			callManufacturersApiDomain(optionDefaultCountryDrop, false);
		}
	}, [optionDefaultCountryDrop?.key]);

	useEffect(() => {
		if (optionDefaultSupplierDrop) {
			callWarehouseApiDomain(optionDefaultSupplierDrop, false);
		}
	}, [optionDefaultSupplierDrop?.key]);

	// Call API's related by queryParams
	useEffect(() => {
		const supplierQueryParams = isNullUndefined(queryParamsValues.supplier) ? null : queryParamsValues.supplier;
		const makeQueryParams = isNullUndefined(queryParamsValues.make) ? null : queryParamsValues.make;
		const modelQueryParams = isNullUndefined(queryParamsValues.model) ? null : queryParamsValues.model;
		if (isNullUndefined(countryReducer.countriesUser.data)) {
			return;
		}
		if (!isNullUndefined(supplierQueryParams)) callWarehouseApiDomain(supplierQueryParams, false);
		if (!isNullUndefined(makeQueryParams)) callModelApiDomain(makeQueryParams, false);
		if (!isNullUndefined(makeQueryParams) && !isNullUndefined(modelQueryParams))
			callSubModelApiDomain(makeQueryParams, modelQueryParams, false);
	}, [JSON.stringify(queryParamsValues), countryReducer.countriesUser.isLoading]);
	// #endregion

	return (
		<>
			{openModalImportInventory && (
				<ModalImportInvetory
					open={openModalImportInventory}
					closeModal={closeModalImportInventory}
					files={filesModalImportInventory}
					setFiles={setFilesModalImportInventory}
					setTabCurrent={setTabCurrent}
					onSearchGrid={(params) => {
						searchGridHistory(params);
					}}
					exporting={exporting}
					setExporting={setExporting}
					uploading={uploading}
					setUploading={setUploading}
				/>
			)}

			<S.Container>
				<Box showBox={showFilters} title={getTranslateByKey("information.filters")}>
					<form onSubmit={customHandleSubmit} noValidate>
						<S.RowInputs>
							<KogAutoCompleteControlled
								required
								label={getTranslateByKey("information.country")}
								control={control}
								options={countryReducer.countriesUser.data}
								isLoading={countryReducer.countriesUser.isLoading}
								nameCustom="country"
								rulesCustom={{ required: true }}
								errorMessageCustom={
									errors.country?.type === "required" ? getTranslateByKey("information.countryRequired", true) : ""
								}
								hasErrorCustom={!!errors.country}
								onChangeCustom={(optionSelected: KeyValue | null) => {
									callSupplierApiDomain(optionSelected);
									callManufacturersApiDomain(optionSelected);
								}}
								autoHighlightCustom={!!optionDefaultCountryDrop}
								setValueCustom={setValue}
								disabled={optionDefaultCountryDrop !== null}
								id="id-partsCatelog-txt-country"
							/>
							<KogAutoCompleteControlled
								required
								label={getTranslateByKey("information.supplier")}
								control={control}
								nameCustom="supplier"
								rulesCustom={{ required: true }}
								errorMessageCustom={
									errors.supplier?.type === "required" ? getTranslateByKey("information.supplierRequired", true) : ""
								}
								hasErrorCustom={!!errors.supplier}
								options={supplierReducer.suppliers.data}
								isLoading={supplierReducer.suppliers.isLoading}
								onChangeCustom={(optionSelected: KeyValue | null) => {
									callWarehouseApiDomain(optionSelected);
								}}
								disabled={isDisabledSupplierDrop() || !!optionDefaultSupplierDrop}
								autoHighlightCustom={!!optionDefaultSupplierDrop}
								setValueCustom={setValue}
								id="id-partsCatelog-txt-supplier"
							/>
							<KogAutoCompleteControlled
								required
								label={getTranslateByKey("information.warehouse")}
								control={control}
								options={warehouseReducer.warehouse.data}
								isLoading={warehouseReducer.warehouse.isLoading}
								nameCustom="warehouse"
								rulesCustom={{ required: true }}
								errorMessageCustom={
									errors.warehouse?.type === "required" ? getTranslateByKey("warehouse.warehouseRequired", true) : ""
								}
								hasErrorCustom={!!errors.warehouse}
								onChangeCustom={() => {}}
								setValueCustom={setValue}
								autoHighlightCustom={!!optionDefaultWarehouseDrop}
								disabled={isDisabledWarehouseDrop() || !!optionDefaultWarehouseDrop}
								id="id-partsCatelog-txt-warehouse"
							/>
						</S.RowInputs>
						<S.RowInputs>
							<KogAutoCompleteVehicleControlled
								label={getTranslateByKey("information.manufacturer")}
								control={control}
								options={manufacturerReducer.manufacturers.data}
								isLoading={manufacturerReducer.manufacturers.isLoading}
								nameCustom="make"
								rulesCustom={{ required: false }}
								errorMessageCustom={
									errors.make?.type === "required" ? getTranslateByKey("information.manufacturerRequired", true) : ""
								}
								hasErrorCustom={!!errors.make}
								onChangeCustom={(optionSelected: KeyValue | null) => {
									callModelApiDomain(optionSelected);
								}}
								setValueCustom={setValue}
								id="id-partsCatelog-txt-make"
							/>
							<KogAutoCompleteVehicleControlled
								label={getTranslateByKey("information.model")}
								control={control}
								options={modelReducer.models.data}
								isLoading={modelReducer.models.isLoading}
								nameCustom="model"
								rulesCustom={{ required: false }}
								errorMessageCustom={
									errors.model?.type === "required" ? getTranslateByKey("information.modelRequired", true) : ""
								}
								hasErrorCustom={!!errors.model}
								onChangeCustom={(optionSelected: KeyValue | null) => {
									callSubModelApiDomain(watcherMake, optionSelected);
								}}
								setValueCustom={setValue}
								disabled={isDisabledModelDrop()}
								id="id-partsCatelog-txt-model"
							/>
							<KogAutoCompleteVehicleControlled
								label={getTranslateByKey("information.trim")}
								control={control}
								options={subModelReducer.subModels.data}
								isLoading={subModelReducer.subModels.isLoading}
								nameCustom="trim"
								rulesCustom={{ required: false }}
								errorMessageCustom={
									errors.trim?.type === "required" ? getTranslateByKey("information.trimRequired", true) : ""
								}
								hasErrorCustom={!!errors.trim}
								onChangeCustom={() => {}}
								setValueCustom={setValue}
								disabled={isDisabledSubModelDrop()}
								id="id-partsCatelog-txt-trim"
							/>
						</S.RowInputs>
						<S.RowInputs>
							<KogInputTextControlledNew
								label={getTranslateByKey("information.sku")}
								name="sku"
								error={!!errors.sku}
								control={control}
								id="id-partsCatelog-txt-sku"
							/>
							<KogInputTextControlledNew
								label={getTranslateByKey("information.title")}
								name="title"
								error={!!errors.title}
								control={control}
								id="id-partsCatelog-txt-title"
							/>
							<KogAutoCompleteControlled
								required
								id="id-searchCatalog-select-companyType"
								label={getTranslateByKey("information.companyType")}
								control={control}
								options={optionsFilteredCompanyType}
								isLoading={companyTypeReducer.companyType.isLoading}
								nameCustom="companyType"
								rulesCustom={{ required: false }}
								errorMessageCustom={
									errors.companyType?.type === "required"
										? getTranslateByKey("information.companyTypeRequired", true)
										: ""
								}
								setValueCustom={setValue}
								hasErrorCustom={!!errors.companyType}
								disabled={isDisabledCompanyTypeDrop()}
								onChangeCustom={(optionSelected: KeyValue | null) => {
									callCompanyApiDomain(getValues().country, optionSelected);
								}}
							/>
						</S.RowInputs>
						<S.RowInputs>
							<KogInputAutoCompleteCheckControlled
								name="company"
								disableSelectAll
								control={control}
								options={companyReducer.company.data || []}
								disableVirtualization
								label={getTranslateByKey("information.company")}
								disabled={isDisabledCompanyDrop()}
								isLoading={companyReducer.company.isLoading}
								controllerProps={{ rules: { required: false } }}
								customInputProps={{
									required: false,
									id: "id-searchimport-select-company",
								}}
								onChangeCustom={(value, optionChanged, reason) => {
									switch (reason) {
										case "selectOption":
											break;
										case "removeOption":
											break;
										case "clear":
											break;
										default:
											break;
									}
								}}
							/>
							<KogAutoCompleteControlled
								label={getTranslateByKey("information.status")}
								nameCustom="supplierInventoryWarehouseStatus"
								errorMessageCustom=""
								control={control}
								setValueCustom={setValue}
								options={supplierInventoryWarehouseStatusReducer.data}
								isLoading={supplierInventoryWarehouseStatusReducer.isLoading}
								rulesCustom={{ required: false }}
								hasErrorCustom={false}
								onChangeCustom={() => {}}
								id="id-importHistory-txt-status"
							/>
						</S.RowInputs>
						<KOGAreaButtons>
							<SecondaryButton type="submit" id="id-partsCatelog-btn-search">
								{getTranslateByKey("information.search")}
							</SecondaryButton>
							<SecondaryButton onClick={handleClear} id="id-partsCatelog-btn-clear">
								{getTranslateByKey("information.clear")}
							</SecondaryButton>
						</KOGAreaButtons>
					</form>
				</Box>

				<SupplierSearchGrid
					isLoadingInfiniteScroll={isLoadingInfiniteScroll}
					pageIndex={pageIndex}
					setPageIndex={setPageIndex}
					hasShowMore={hasShowMore}
					gridData={gridData}
					formFilters={formFilters}
					setFormFilters={setFormFilters}
					getGridData={(request: SupplierFilterRequest) => {
						onLoadInfiniteScroll(request);
					}}
					refreshGrid={refreshGrid}
				/>
			</S.Container>
		</>
	);
}

// export default PartsCatalogTab;
export default withQueryparams(PartsCatalogTab, {
	customName: "partsCatalogTab",
	validateQueryParams: {
		tab: ID_TAB_PARTS_CATALOG,
	},
});
